import React from 'react';
import CameraFrame from '../../components/ui/CameraFrame';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCheckCircle, FiClock, FiLock } = FiIcons;

const WorkflowStep = ({ step, active, onClick }) => {
  const getStatusIcon = () => {
    if (step.status === 'success') return <SafeIcon icon={FiCheckCircle} className="text-green-500" />;
    if (step.status === 'in-progress') return <SafeIcon icon={FiClock} className="text-yellow-500 animate-pulse" />;
    return <SafeIcon icon={FiLock} className="text-[#444]" />;
  };

  return (
    <button 
      onClick={onClick}
      className={`w-full text-left transition-all duration-300 ${active ? 'scale-[1.02] z-10' : 'opacity-60 hover:opacity-100'}`}
    >
      <CameraFrame active={active} className={`p-4 ${active ? 'bg-[#1a1a1a]' : 'bg-[#111]'}`}>
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 mt-1">
            {getStatusIcon()}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex justify-between items-center mb-1">
              <span className="font-mono text-[10px] text-pink-500 tracking-widest uppercase">STEP 0{step.step}</span>
              <span className="font-mono text-[9px] text-[#555] border border-[#333] px-1">{step.module}</span>
            </div>
            <h4 className="text-sm font-bold text-white truncate">{step.title}</h4>
            {active && (
              <p className="text-xs text-[#888] mt-2 leading-relaxed animate-in fade-in slide-in-from-top-1">
                {step.description}
              </p>
            )}
          </div>
        </div>
      </CameraFrame>
    </button>
  );
};

export default WorkflowStep;